const GA_MEASUREMENT_ID =
  process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID ||
  (process.env.NODE_ENV === 'production' ? 'G-MGKMCSXE9S' : '');

const getSiteType = (url?: string) => {
  if (!url && typeof window !== 'undefined') {
    return window.location.pathname.includes('/blog') ? 'blog' : 'service';
  }
  return url?.includes('/blog') ? 'blog' : 'service';
};

const ensureGtag = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = (...args: unknown[]) => {
      window.dataLayer?.push(args);
    };
  }
  return window.gtag;
};

export const pageview = (url: string, locale?: string) => {
  if (!GA_MEASUREMENT_ID) {
    return;
  }
  const gtag = ensureGtag();
  if (!gtag) {
    return;
  }
  const pageLocation =
    typeof window !== 'undefined' ? window.location.href : undefined;
  gtag('event', 'page_view', {
    page_location: pageLocation,
    page_path: url,
    send_to: GA_MEASUREMENT_ID,
    site_type: getSiteType(url),
    locale,
  });
};

export const logEvent = (
  category = '',
  action = '',
  _tracker = 'apptracker',
  params: Record<string, unknown> = {},
  locale?: string,
) => {
  if (!GA_MEASUREMENT_ID) {
    return;
  }
  if (!category || !action) {
    return;
  }
  const gtag = ensureGtag();
  if (!gtag) {
    return;
  }
  gtag('event', action, {
    event_category: category,
    site_type: getSiteType(),
    locale,
    ...params,
  });
};

export { GA_MEASUREMENT_ID };
